import { EMPTY_PREBID_MODULE, MultipleEditPayload, PrebidModule, PrebidModuleDataBySite } from '@pubstack/common/src/prebidModule'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { putRenderingModule, useMultipleEditRenderingModule, useRenderingModule } from '~/api/adm/rendering-module.api'
import { usePrebidModulesCatalog } from '~/api/catalog.api'
import { useToast } from '~/components/Toast/useToasts'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { PureAdmPrebidModulePage } from '~/modules/adm/inventory/modules/PureAdmPrebidModulePage'
import { configurationState } from '~/state'

export const AdmRenderingModulePage = () => {
  const { STATIC_ASSETS_CDN } = useAtomValue(configurationState)
  const { moduleId } = useParams()
  const { byId: catalogById, isLoading: isCatalogLoading } = usePrebidModulesCatalog()
  const prebidModule: PrebidModule = (moduleId ? catalogById[moduleId] : undefined) ?? { ...EMPTY_PREBID_MODULE, type: 'Rendering' }
  const toast = useToast()
  const navigate = useNavigate()

  const breadcrumbs = useBreadcrumbs({ integrationName: prebidModule?.displayName ?? '' })

  const { data: renderingData = [], isPending } = useRenderingModule(moduleId ?? '')
  const { mutateAsync: multipleEdit } = useMultipleEditRenderingModule(moduleId ?? '')

  const updateSiteRendering = async (data: PrebidModuleDataBySite<'Rendering'>) => {
    try {
      if (moduleId && prebidModule) {
        await putRenderingModule(moduleId, data.siteId, { name: prebidModule.code, ...data.moduleData }, data.enabled)
        toast.admSuccess(data.label, true, navigate)
      }
    } catch (_e) {
      toast.alert('An error has occurred, please retry later.')
    }
  }

  const onMultipleEdit = async (payload: MultipleEditPayload<'Rendering'>) => {
    try {
      await multipleEdit(payload)
      toast.admSuccess(`${payload.selectedSites.length} site${payload.selectedSites.length > 1 ? 's' : ''}`, true, navigate)
    } catch (_e) {
      toast.alert('An error has occurred, please retry later.')
    }
  }

  const data = useMemo(
    () =>
      renderingData.map(({ moduleData, ...rest }) => ({
        ...rest,
        moduleData: moduleData ?? prebidModule?.defaultValues,
      })),
    [renderingData, prebidModule]
  )

  return (
    <PureAdmPrebidModulePage
      prebidModule={prebidModule}
      breadcrumbs={breadcrumbs}
      data={data}
      helpText={'Rendering'}
      isLoading={isPending || isCatalogLoading}
      updateSiteData={updateSiteRendering}
      baseCDNUrl={STATIC_ASSETS_CDN}
      onBackClick={() => navigate(-1)}
      onMultipleEdit={onMultipleEdit}
    />
  )
}
